import { render } from "./App.vue?vue&type=template&id=d5cb2bf8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d5cb2bf8&lang=scss"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__